import { render, staticRenderFns } from "./reservaInfo.vue?vue&type=template&id=51ad6562"
import script from "./reservaInfo.vue?vue&type=script&lang=js"
export * from "./reservaInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports